import { render, staticRenderFns } from "./ChangeProject.vue?vue&type=template&id=1fa86ce6&scoped=true&"
import script from "./ChangeProject.vue?vue&type=script&lang=js&"
export * from "./ChangeProject.vue?vue&type=script&lang=js&"
import style0 from "./ChangeProject.vue?vue&type=style&index=0&id=1fa86ce6&prod&lang=css&"
import style1 from "./ChangeProject.vue?vue&type=style&index=1&id=1fa86ce6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa86ce6",
  null
  
)

export default component.exports